// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lJpdO","textarea":"styles_textarea__1iOu5"};